module.exports = __webpack_public_path__ + "img/SketchPng7da2b64085dd065e339463c37ac7c6e02e0a7edcee99fa3b234e96642ed7dc7c.c22717f8.png";